import { IconChevronDown, IconPlus, IconSparkles, IconTemplate } from "@tabler/icons-react";
import { useNavigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Spinner } from "@/components/ui/spinner";

export function CampaignCreateMenu({
  smartCreationPending,
  smartCreationDisabled,
  onCreateManual,
  onCreateSmart,
}: {
  smartCreationPending: boolean;
  smartCreationDisabled: boolean;
  onCreateManual: () => void;
  onCreateSmart: () => void;
}) {
  const { t } = useTranslation("campaign");
  const { t: smartT } = useTranslation("smartCreation");
  const { t: templateT } = useTranslation("templatePortfolio");
  const navigate = useNavigate();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger render={<Button size="sm" />}>
        {smartCreationPending ? (
          <Spinner data-icon="inline-start" />
        ) : (
          <IconPlus data-icon="inline-start" />
        )}
        {smartCreationPending ? smartT("entry.preparing") : t("list.create")}
        <IconChevronDown data-icon="inline-end" />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" sideOffset={6} className="w-72 p-1.5">
        <DropdownMenuGroup>
          <DropdownMenuItem className="items-start gap-2.5 p-2" onClick={onCreateManual}>
            <IconPlus className="mt-0.5 size-4" />
            <span className="flex flex-col gap-0.5">
              <span className="font-medium">{smartT("entry.manual")}</span>
              <span className="text-xs text-muted-foreground">
                {smartT("entry.manualDescription")}
              </span>
            </span>
          </DropdownMenuItem>
          <DropdownMenuItem
            className="items-start gap-2.5 p-2"
            disabled={smartCreationDisabled}
            onClick={onCreateSmart}
          >
            <IconSparkles className="mt-0.5 size-4" />
            <span className="flex flex-col gap-0.5">
              <span className="font-medium">{smartT("entry.smart")}</span>
              <span className="text-xs text-muted-foreground">
                {smartT("entry.smartDescription")}
              </span>
            </span>
          </DropdownMenuItem>
          <DropdownMenuItem
            className="items-start gap-2.5 p-2"
            onClick={() => void navigate({ to: "/campaigns/template-portfolio" })}
          >
            <IconTemplate className="mt-0.5 size-4" />
            <span className="flex flex-col gap-0.5">
              <span className="font-medium">{templateT("entry.label")}</span>
              <span className="text-xs text-muted-foreground">
                {templateT("entry.description")}
              </span>
            </span>
          </DropdownMenuItem>
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
